import { makeDefaultReducer } from "../../common/utils";

const actionTypes = {
  LOAD: "genericalerts/load",
  LOAD_SUCCESS: "genericalerts/load_success",
  LOAD_FAILED: "genericalerts/load_failed",
};

export const reducer = makeDefaultReducer(actionTypes);

export const loadGenericAlerts = () => ({
  types: [actionTypes.LOAD, actionTypes.LOAD_SUCCESS, actionTypes.LOAD_FAILED],
  method: "GET",
  url: `/genericalerts/`,
});

export const getGenericAlerts = state => {
  const {
    genericalert: { items = {}, loading, loaded, error, count },
  } = state;
  const visibleItems = Object.keys(items).map(key => items[key]);
  return {
    items: visibleItems,
    loading,
    loaded,
    error,
    count,
  };
};

const pageFlagMap = {
  home: "show_on_homepage",
  congestions: "show_on_congestions",
  roadworks: "show_on_roadworks",
  route: "show_on_route",
};

export const getLatestGenericAlertForPage = (state, page) => {
  const { items = [] } = getGenericAlerts(state);
  const flag = pageFlagMap[page];
  if (!flag) return null;
  const filtered = items.filter(item => Boolean(item?.[flag]));
  if (filtered.length === 0) return null;
  // Return the item with the highest id
  return filtered.reduce((max, item) => (item.id > (max?.id || 0) ? item : max), null);
};
